import RFTrigger from '@/form/register/RFTrigger.tsx';

const AnyTimeCTA = () => {
  return (
    <div className="container">
      <div className="pt-10 pb-16 text-center">
        <h2 className="text-[50px]">Anytime, Anywhere.</h2>
        <p className="text-[20px] mt-6 mb-8">
          Cloud Based management systeem die u weer die kostbare tijd geeft.
          Zodat u zich weer kunt gaan concentreren op de dienstkwaliteit en de
          groei van uw bedrijf.
        </p>

        <div>
          <RFTrigger />
        </div>
      </div>
    </div>
  );
};

export default AnyTimeCTA;
